import EmberObject from '../../../object/index.js';

class ComponentLookup extends EmberObject {
  componentFor(name, owner) {
    let fullName = `component:${name}`;
    return owner.factoryFor(fullName);
  }
  layoutFor(name, owner, options) {
    let templateFullName = `template:components/${name}`;
    return owner.lookup(templateFullName, options);
  }
}

export { ComponentLookup as default };
